import { Aviso } from "../ui";
import type { PainelParaVer } from "../../nucleo/paineis";
import { WidgetDoPainel } from "./WidgetDoPainel";

/** A grade de 4 colunas do painel (em tela estreita, uma coluna): ordem e largura vêm do painel. */
export function GradeDoPainel({ painel }: { painel: PainelParaVer }) {
  if (painel.widgets.length === 0) {
    return <Aviso tom="neutro">Nenhum widget deste painel está liberado para o seu acesso.</Aviso>;
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-6" data-testid="grade-do-painel">
      {painel.widgets.map((widget) => (
        <WidgetDoPainel key={widget.id} widget={widget} />
      ))}
    </div>
  );
}
